import {
  statusMenu,
  sentStatusMenu,
  corporationSentStatusMenu,
  followCallOrderStatusMenu,
  downloadStatusMenu,
  investBusinessAreaNestedMenu,
  webToolNestedMenu,
  corporationStatisticsChangeNestedMenu,
  honorificNestedMenu,
  departmentNestedMenu,
  industryMenu,
  prefectureNameMenu,
  jsicMenu,
  optionMenu,
  amountOfSalesMenu,
  businessTypeMenu,
  numberOfEmployeesMenu,
  numberOfStoresMenu,
  capitalStockMenu,
  listingTypeMenu,
  listingStatusMenu,
  clothingMonthMenu,
  averageAgeMenu,
  averageAnnualIncomeMenu,
  fundraisingDaysMenu,
  fundraisingAmountRangeMenu,
  fundraisingRoundMenu,
  fundraisingFinancingTypeMenu,
  fundraisingInvestorTypeMenu,
  fundraisingAmountTypeMenu,
} from './SidebarValues';
import { createValueToEntryMap } from '../utils/utils';
import { createDateRangeFormatter } from '../utils/executiveListUtils';
import { Set, Map } from 'immutable';
import SelectIndustryCategoryDialog from '../components/ExecutiveList/dialogs/SelectHierarchicalMenuDialog/SelectIndustryCategoryDialog';
import SelectJsicDialog from '../components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectJsicDialog';
import SelectDepartmentDialog from '../components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectDepartmentDialog';
import SelectHonorificDialog from '../components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectHonorificDialog';
import SelectInvestBusinessAreaDialog from '../components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectInvestBusinessAreaDialog';
import SelectWebToolDialog from '../components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectWebToolDialog';
import SelectCorporationStatisticsChangeDialog from '../components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectCorporationStatisticsChangeDialog';

// 設定オブジェクトから動的に初期状態を生成する汎用関数

/**
 * 設定オブジェクトから動的に初期状態を生成する汎用関数
 * @param {Object} configObject 設定オブジェクト
 * @param {Object} options オプション
 * @returns 初期状態
 *
 * keyとinitialValueが設定されている場合は、その値を初期状態に設定する。
 * dialogShowStateKeyとdialogShowInitialValueが設定されている場合は、その値を初期状態に設定する。
 * includeIsAndSearchStateとisAndSearchInitialValueが設定されている場合は、その値を初期状態に設定する。
 */
export const generateConfigInitialState = (configObject, options = {}) => {
  const {
    includeDialogState = false, // ダイアログ表示状態を含めるかどうか
    dialogStateInitialValue = false, // ダイアログ状態の初期値
    includeShowKeywordTextfieldState = false, // キーワードテキストフィールド表示状態を含めるかどうか
    showKeywordTextfieldInitialValue = false // キーワードテキストフィールド表示状態の初期値
  } = options;

  const initialState = {};

  Object.values(configObject).forEach(config => {
    // 各設定の初期値を設定
    if (config.initialValue !== undefined) {
      initialState[config.key] = config.initialValue;
    }

    // ダイアログ表示状態を含める場合
    if (includeDialogState && config && config.dialogShowStateKey) {
      initialState[config.dialogShowStateKey] = true;
      initialState[config.dialogShowStateKey] = config.dialogShowInitialValue !== undefined
        ? config.dialogShowInitialValue
        : dialogStateInitialValue;
    }

    // キーワードテキストフィールド表示状態を含める場合
    if (includeShowKeywordTextfieldState && config && config.showKeywordTextfieldStateKey) {
      initialState[config.showKeywordTextfieldStateKey] = config.showKeywordTextfieldInitialValue !== undefined
        ? config.showKeywordTextfieldInitialValue
        : showKeywordTextfieldInitialValue;
    }
  });

  return initialState;
};

// 各メニューのvalue to entry マップを作成
const industryValueToEntryMap = createValueToEntryMap(industryMenu);
const prefectureValueToEntryMap = createValueToEntryMap(prefectureNameMenu);
const investBusinessAreaValueToEntryMap = createValueToEntryMap(investBusinessAreaNestedMenu);
const webToolValueToEntryMap = createValueToEntryMap(webToolNestedMenu);
const departmentValueToEntryMap = createValueToEntryMap(departmentNestedMenu);
const honorificValueToEntryMap = createValueToEntryMap(honorificNestedMenu);
const jsicValueToEntryMap = createValueToEntryMap(jsicMenu);
const sentStatusValueToEntryMap = createValueToEntryMap(sentStatusMenu);
const corporationSentStatusValueToEntryMap = createValueToEntryMap(corporationSentStatusMenu);
const followCallOrderStatusValueToEntryMap = createValueToEntryMap(followCallOrderStatusMenu);
const downloadStatusValueToEntryMap = createValueToEntryMap(downloadStatusMenu);
const statusValueToEntryMap = createValueToEntryMap(statusMenu);
const corporationStatisticsChangeValueToEntryMap = createValueToEntryMap(corporationStatisticsChangeNestedMenu);
// TODO 将来的にはexportしているconstを統合して対応したい例SEARCH_KEY_CONFIGのような形
// 通常のネストメニューのマッピング
export const MAP_MENU_CONFIG = {
  honorific: {
    key: 'honorific',
    property: 'honorific',
    initialValue: Map(),
    dialogShowStateKey: 'showSelectHonorificDialog',
    dialogShowInitialValue: false,
    component: SelectHonorificDialog,
    menu: honorificNestedMenu,
    map: honorificValueToEntryMap,
    category: '役職',
    labelFormatter: (label) => label,
    hasParentMenu: true
  },
  invest_business_area: {
    key: 'invest_business_area',
    property: 'invest_business_area',
    initialValue: Map(),
    dialogShowStateKey: 'showSelectInvestBusinessAreaDialog',
    dialogShowInitialValue: false,
    component: SelectInvestBusinessAreaDialog,
    menu: investBusinessAreaNestedMenu,
    map: investBusinessAreaValueToEntryMap,
    category: '投資意欲',
    labelFormatter: (label) => "投資意欲: " + label,
    hasParentMenu: true
  },
  web_tool: {
    key: 'web_tool',
    property: 'web_tool',
    initialValue: Map(),
    dialogShowStateKey: 'showSelectWebToolDialog',
    dialogShowInitialValue: false,
    component: SelectWebToolDialog,
    menu: webToolNestedMenu,
    map: webToolValueToEntryMap,
    category: '導入ウェブツール',
    labelFormatter: (label) => "導入ウェブツール: " + label,
    hasParentMenu: true
  },
  corporation_statistics_change: {
    key: 'corporation_statistics_change',
    property: 'corporation_statistics_change',
    initialValue: Map(),
    dialogShowStateKey: 'showSelectCorporationStatisticsChangeDialog',
    dialogShowInitialValue: false,
    component: SelectCorporationStatisticsChangeDialog,
    menu: corporationStatisticsChangeNestedMenu,
    map: corporationStatisticsChangeValueToEntryMap,
    category: '企業統計情報の動向',
    labelFormatter: (label) => "企業統計情報の動向: " + label,
    hasParentMenu: true
  },
  // TODO industry_minor_category_idsになるので消す予定
  jsic: {
    key: 'jsic',
    property: 'jsic',
    initialValue: Map(),
    dialogShowStateKey: 'showSelectJsicDialog',
    dialogShowInitialValue: false,
    component: SelectJsicDialog,
    menu: jsicMenu,
    map: jsicValueToEntryMap,
    category: '業界',
    labelFormatter: (label) => label
  },
  department: {
    key: 'department',
    property: 'department',
    initialValue: Map(),
    dialogShowStateKey: 'showSelectDepartmentDialog',
    dialogShowInitialValue: false,
    component: SelectDepartmentDialog,
    extraProps: ['researchedTelHasDepartmentKeys'],
    menu: departmentNestedMenu,
    map: departmentValueToEntryMap,
    category: '部門',
    labelFormatter: (label) => "部門: " + label,
    hasParentMenu: true
  },
  industry: {
    key: 'industry',
    property: 'industry',
    initialValue: Map(),
    menu: industryMenu,
    map: industryValueToEntryMap,
    category: '業界',
    labelFormatter: (label) => label
  },
  prefecture_name: {
    key: 'prefecture_name',
    property: 'prefecture_name',
    initialValue: Map(),
    menu: prefectureNameMenu,
    map: prefectureValueToEntryMap,
    category: '地域',
    labelFormatter: (label) => label
  },
  timeline_status: {
    key: 'timeline_status',
    property: 'timeline_status',
    initialValue: Map(),
    menu: statusMenu,
    map: statusValueToEntryMap,
    category: 'ステータス',
    labelFormatter: (label, entry) => entry ? `${entry.parent_name} : ${label}` : label
  },
  download_status: {
    key: 'download_status',
    property: 'download_status',
    initialValue: Map(),
    menu: downloadStatusMenu,
    map: downloadStatusValueToEntryMap,
    category: '送信ステータス',
    labelFormatter: (label, entry) => entry ? `${entry.parent_name} : ${label}` : label
  }
};

export const HIERARCHICAL_MENU_CONFIG = {
  industry_minor_category_ids: {
    key: 'industry_minor_category_ids',
    property: 'industry_minor_category_ids',
    initialValue: Set(),
    dialogShowStateKey: 'showSelectIndustryCategoryDialog',
    dialogShowInitialValue: false,
    component: SelectIndustryCategoryDialog,
    menuListKey: 'industryCategoryList',
    category: '業界',
    labelFormatter: (label) => "業界: " + label,
  }
};

// 業種検索モードの設定
export const INDUSTRY_SEARCH_MODE_CONFIG = {
  industry_search_mode: {
    key: 'industry_search_mode',
    property: 'industry_search_mode',
    initialValue: 'all', // 'all' or 'primary_only'
    category: '業種検索モード',
    labelFormatter: (mode) => mode === 'primary_only' ? 'メイン業種のみ' : '全業種',
  }
};

export const KEYWORD_SEARCH_CONFIG = {
  reaction_keyword: {
    key: 'reaction_keyword',
    property: 'reaction_keyword',
    initialValue: '',
    ui: {
      typeName: 'キーマンが関心のあるキーワード',
      placeholder: 'セミナー SaaS',
      tooltipText: 'キーマンの関心のあるキーワードで検索することができます。複数のキーワードは空白で区切って入力してください。',
      toolTipPlacement: 'bottom',
    },
    label: '関心のあるキーワード',
    category: '関心のあるキーワード'
  },
  // reaction_exclude_keyword(キーマンが関心のあるキーワード除外)はES側の原因不明のバグがあるため一旦削除 (2025/09/29時点で確認できてないが治っている可能性もあるが要望あれば復活させる)
  company_keyword: {
    key: 'company_keyword',
    property: 'company_keyword',
    initialValue: '',
    ui: {
      typeName: '会社名で検索',
      placeholder: 'oo株式会社 oo株式会社',
      tooltipText: '会社名で検索することができます。複数の会社名は空白で区切って入力してください。',
      toolTipPlacement: 'bottom',
    },
    label: '会社名',
    category: '会社名'
  },
  company_exclude_keyword: {
    key: 'company_exclude_keyword',
    property: 'company_exclude_keyword',
    initialValue: '',
    showKeywordTextfieldStateKey: 'showCompanyExcludeKeywordTextfield',
    showKeywordTextfieldInitialValue: false,
    label: '除外キーワード(会社名)',
    category: '除外キーワード(会社名)'
  },
  corporate_number_keyword: {
    key: 'corporate_number_keyword',
    property: 'corporate_number_keyword',
    initialValue: '',
    ui: {
      typeName: '法人番号で検索',
      tooltipText: '法人番号で検索することができます。複数の法人番号は空白で区切って入力してください。',
      placeholder: '9010401052465 1180301018771',
    },
    label: '法人番号',
    category: '法人番号'
  },
  corporate_number_exclude_keyword: {
    key: 'corporate_number_exclude_keyword',
    property: 'corporate_number_exclude_keyword',
    initialValue: '',
    showKeywordTextfieldStateKey: 'showCorporateNumberExcludeKeywordTextfield',
    showKeywordTextfieldInitialValue: false,
    label: '除外キーワード(法人番号)',
    category: '除外キーワード(法人番号)'
  },
  corporation_feature_keyword: {
    key: 'corporation_feature_keyword',
    property: 'corporation_feature_keyword',
    initialValue: '',
    ui: {
      typeName: '会社概要で検索',
      placeholder: '会社概要',
      tooltipText: '会社概要で検索することができます。複数の会社概要は空白で区切って入力してください。',
      toolTipPlacement: 'bottom',
    },
    label: '会社概要',
    category: '会社概要',
    isNew: true,
  },
  corporation_feature_exclude_keyword: {
    key: 'corporation_feature_exclude_keyword',
    property: 'corporation_feature_exclude_keyword',
    initialValue: '',
        ui: {
      tooltipText: '会社概要で除外検索することができます。複数の会社概要は空白で区切って入力してください。',
    },
    showKeywordTextfieldStateKey: 'showCorporationFeatureExcludeKeywordTextfield',
    showKeywordTextfieldInitialValue: false,
    label: '除外キーワード(会社概要)',
    category: '除外キーワード(会社概要)',
  },
  keyman_name_keyword: {
    key: 'keyman_name_keyword',
    property: 'keyman_name_keyword',
    initialValue: '',
    ui: {
      typeName: '名前で検索',
      placeholder: '山田太郎 田中太郎',
      tooltipText: '名前で検索することができます。複数の名前は空白で区切って入力してください。',
      toolTipPlacement: 'bottom',
    },
    label: '名前',
    category: '名前'
  },
  keyman_name_exclude_keyword: {
    key: 'keyman_name_exclude_keyword',
    property: 'keyman_name_exclude_keyword',
    initialValue: '',
    showKeywordTextfieldStateKey: 'showKeymanNameExcludeKeywordTextfield',
    showKeywordTextfieldInitialValue: false,
    label: '除外キーワード(名前)',
    category: '除外キーワード(名前)'
  },
  exe_feature_keyword: {
    key: 'exe_feature_keyword',
    property: 'exe_feature_keyword',
    initialValue: '',
    ui: {
      typeName: '肩書きで検索',
      placeholder: '取締役 CFO',
      tooltipText: '肩書きで検索することができます。複数の肩書きは空白で区切って入力してください。',
      toolTipPlacement: 'bottom',
    },
    label: '肩書き',
    category: '肩書き'
  },
  exe_feature_exclude_keyword: {
    key: 'exe_feature_exclude_keyword',
    property: 'exe_feature_exclude_keyword',
    initialValue: '',
    ui: {
      tooltipText: '肩書きで除外検索することができます。複数の肩書きは空白で区切って入力してください。',
    },
    showKeywordTextfieldStateKey: 'showExeFeatureExcludeKeywordTextfield',
    showKeywordTextfieldInitialValue: false,
    label: '除外キーワード(肩書き)',
    category: '除外キーワード(肩書き)'
  },
}

// AND/OR検索の状態キーと初期値を独立管理
export const KEYWORD_SEARCH_IS_AND_CONFIG = {
  is_and_search_reaction_keyword: {
    key: 'is_and_search_reaction_keyword',
    property: 'is_and_search_reaction_keyword',
    initialValue: true,
  },
  is_and_search_company_keyword: {
    key: 'is_and_search_company_keyword',
    property: 'is_and_search_company_keyword',
    initialValue: true,
  },
  is_and_search_corporation_feature_keyword: {
    key: 'is_and_search_corporation_feature_keyword',
    property: 'is_and_search_corporation_feature_keyword',
    initialValue: true,
  },
  is_and_search_corporation_feature_exclude_keyword: {
    key: 'is_and_search_corporation_feature_exclude_keyword',
    property: 'is_and_search_corporation_feature_exclude_keyword',
    initialValue: true,
  },
  is_and_search_keyman_name_keyword: {
    key: 'is_and_search_keyman_name_keyword',
    property: 'is_and_search_keyman_name_keyword',
    initialValue: true,
  },
  is_and_search_exe_feature_keyword: {
    key: 'is_and_search_exe_feature_keyword',
    property: 'is_and_search_exe_feature_keyword',
    initialValue: true,
  },
  is_and_search_exe_feature_exclude_keyword: {
    key: 'is_and_search_exe_feature_exclude_keyword',
    property: 'is_and_search_exe_feature_exclude_keyword',
    initialValue: true,
  },
};

// ユーザーリストのフィルター設定
export const USER_LIST_FILTER_CONFIG = {
  tag: {
    key: 'tag',
    property: 'tag',
    initialValue: Set(),
    label: 'リスト(含む)',
    category: 'リスト(含む)'
  },
  exclude_list: { // リスト(除く) 元々リスト検索はtagで行っていたが、リスト(除く)を追加した際、投資意欲タグとミスリードしそうなのでexclude_listにした
    key: 'exclude_list',
    property: 'exclude_list',
    initialValue: Set(),
    label: 'リスト(除く)',
    category: 'リスト(除く)'
  }
}

export const CORPORATION_RELATIONSHIPS_CONFIG = {
  corporation_id: {
    key: 'corporation_id',
    property: 'corporation_id',
    initialValue: Set(),
    label: 'ライバル企業のキーマン',
    category: 'ライバル企業のキーマン'
  },
  child_corporation_ids: {
    key: 'child_corporation_ids',
    property: 'child_corporation_ids',
    initialValue: Set(),
    label: '子会社のキーマン',
    category: '子会社のキーマン'
  },
  parent_corporation_ids: {
    key: 'parent_corporation_ids',
    property: 'parent_corporation_ids',
    initialValue: Set(),
    label: '親会社のキーマン',
    category: '親会社のキーマン'
  },
  include_parent_and_child_corporation_ids: {
    key: 'include_parent_and_child_corporation_ids',
    property: 'include_parent_and_child_corporation_ids',
    initialValue: Set(),
    label: '親会社と子会社を含めたキーマン',
    category: '親会社と子会社を含めたキーマン'
  },
}

export const CORPORATION_RELATIONSHIPS_LABEL_CONFIG = {
  rival_label: {
    key: 'rival_label',
    property: 'rival_label',
    initialValue: '',
    label: 'ライバル企業のキーマン',
    category: 'ライバル企業のキーマン'
  },
  child_corporation_ids_label: {
    key: 'child_corporation_ids_label',
    property: 'child_corporation_ids_label',
    initialValue: '',
    label: '子会社のキーマン',
    category: '子会社のキーマン'
  },
  parent_corporation_ids_label: {
    key: 'parent_corporation_ids_label',
    property: 'parent_corporation_ids_label',
    initialValue: '',
    label: '親会社のキーマン',
    category: '親会社のキーマン'
  },
  include_parent_and_child_corporation_ids_label: {
    key: 'include_parent_and_child_corporation_ids_label',
    property: 'include_parent_and_child_corporation_ids_label',
    initialValue: '',
    label: '親会社と子会社を含めたキーマン',
    category: '親会社と子会社を含めたキーマン'
  }
}

// オペレーター用絞り込み
export const KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG = {
  include_field_appointment_user_ids: {
    key: 'include_field_appointment_user_ids',
    property: 'include_field_appointment_user_ids',
    initialValue: false,
    label: '商談獲得実績あり',
    category: '商談獲得実績あり'
  },
  include_field_connect_user_ids: {
    key: 'include_field_connect_user_ids',
    property: 'include_field_connect_user_ids',
    initialValue: false,
    label: 'コネクト実績あり',
    category: 'コネクト実績あり'
  },
  include_field_non_connect_user_ids: {
    key: 'include_field_non_connect_user_ids',
    property: 'include_field_non_connect_user_ids',
    initialValue: false,
    label: '未コネクト実績あり',
    category: '未コネクト実績あり'
  },
  include_field_sent_document_user_ids: {
    key: 'include_field_sent_document_user_ids',
    property: 'include_field_sent_document_user_ids',
    initialValue: false,
    label: '資料送付済み実績あり',
    category: '資料送付済み実績あり'
  },
  include_field_qr_code_reaction_user_ids: {
    key: 'include_field_qr_code_reaction_user_ids',
    property: 'include_field_qr_code_reaction_user_ids',
    initialValue: false,
    label: 'QRコードリアクション実績あり',
    category: 'QRコードリアクション実績あり'
  },
  include_field_close_user_ids: {
    key: 'include_field_close_user_ids',
    property: 'include_field_close_user_ids',
    initialValue: false,
    label: 'クローズ実績あり',
    category: 'クローズ実績あり'
  },
  include_field_declined_user_ids: {
    key: 'include_field_declined_user_ids',
    property: 'include_field_declined_user_ids',
    initialValue: false,
    label: 'お断り実績あり',
    category: 'お断り実績あり'
  },
  include_field_approach_ng_user_ids: {
    key: 'include_field_approach_ng_user_ids',
    property: 'include_field_approach_ng_user_ids',
    initialValue: false,
    label: 'アプローチNG実績あり',
    category: 'アプローチNG実績あり'
  }
}

// 日付範囲フィルターを持つステータスメニューの定義
export const MAP_MENU_OPTIONAL_DATE_RANGE_CONFIG = {
  sent_status: {
    menu: sentStatusMenu,
    map: sentStatusValueToEntryMap,
    category: '送信ステータス',
    labelFormatter: (label, entry) => entry ? `${entry.parent_name} : ${label}` : label,
    clearFields: {
      '注文済みキーマンのみを表示': ['sent_only_from', 'sent_only_to'],
      '注文済みキーマンを除外': ['sent_except_from', 'sent_except_to']
    },
    dateRangeFormatter: createDateRangeFormatter('sent_status')
  },
  corporation_sent_status: {
    menu: corporationSentStatusMenu,
    map: corporationSentStatusValueToEntryMap,
    category: '送信ステータス',
    labelFormatter: (label, entry) => entry ? `${entry.parent_name} : ${label}` : label,
    clearFields: {
      '注文済み企業のみを表示': ['corporation_sent_only_from', 'corporation_sent_only_to'],
      '注文済み企業を除外': ['corporation_sent_except_from', 'corporation_sent_except_to']
    },
    dateRangeFormatter: createDateRangeFormatter('corporation_sent_status')
  },
  follow_call_order_status: {
    menu: followCallOrderStatusMenu,
    map: followCallOrderStatusValueToEntryMap,
    category: '送信ステータス',
    labelFormatter: (label, entry) => entry ? `${entry.parent_name} : ${label}` : label,
    clearFields: {
      'フォローコール依頼済みのみを表示': ['follow_call_order_only_from', 'follow_call_order_only_to'],
      'フォローコール依頼済みを除外': ['follow_call_order_except_from', 'follow_call_order_except_to']
    },
    dateRangeFormatter: createDateRangeFormatter('follow_call_order_status')
  }
};

// デイリー通知する項目の設定
export const DAILY_NOTIFICATION_FILTER_CONFIG = {
  add_keyman_filter: {
    key: 'add_keyman_filter',
    property: 'add_keyman_filter',
    initialValue: "",
    label: '更新されたキーマン'
  },
  del_keyman_filter: {
    key: 'del_keyman_filter',
    property: 'del_keyman_filter',
    initialValue: "",
    label: '退任したキーマン'
  },
  exists_department_tel_keyman_filter: {
    key: 'exists_department_tel_keyman_filter',
    property: 'exists_department_tel_keyman_filter',
    initialValue: "",
    label: '部門電話番号が取得できたキーマン'
  },
  recommend_keyman_filter: {
    key: 'recommend_keyman_filter',
    property: 'recommend_keyman_filter',
    initialValue: "",
    label: 'おすすめのキーマン',
    description: '貴社のターゲットに当てはまるキーマンをKeyman Letterの実績からAIと独自のアルゴリズムでレコメンドしています。'
  }
};

/**
 * シンプルなメニューフィルターの設定
 * 
 * Set型のフィルター値とメニュー配列を紐付ける設定オブジェクト
 */
export const SIMPLE_MENU_FILTER_CONFIG = {
  option_menu: {
    key: 'option_menu',
    property: 'option_menu',
    initialValue: Set(),
    menu: optionMenu,
    category: 'その他オプション'
  },
  amount_of_sales: {
    key: 'amount_of_sales',
    property: 'amount_of_sales',
    initialValue: Set(),
    menu: amountOfSalesMenu,
    category: '売上高'
  },
  business_type: {
    key: 'business_type',
    property: 'business_type',
    initialValue: Set(),
    menu: businessTypeMenu,
    category: '事業形態'
  },
  number_of_employees: {
    key: 'number_of_employees',
    property: 'number_of_employees',
    initialValue: Set(),
    menu: numberOfEmployeesMenu,
    category: '従業員数'
  },
  number_of_stores: {
    key: 'number_of_stores',
    property: 'number_of_stores',
    initialValue: Set(),
    menu: numberOfStoresMenu,
    category: '店舗数'
  },
  capital_stock: {
    key: 'capital_stock',
    property: 'capital_stock',
    initialValue: Set(),
    menu: capitalStockMenu,
    category: '資本金'
  },
  listing_type: {
    key: 'listing_type',
    property: 'listing_type',
    initialValue: Set(),
    menu: listingTypeMenu,
    category: '上場市場'
  },
  listing_status: {
    key: 'listing_status',
    property: 'listing_status',
    initialValue: Set(),
    menu: listingStatusMenu,
    category: '上場に関する状態'
  },
  clothing_month: {
    key: 'clothing_month',
    property: 'clothing_month',
    initialValue: Set(),
    menu: clothingMonthMenu,
    category: '決算月'
  },
  age: {
    key: 'age',
    property: 'age',
    initialValue: Set(),
    menu: averageAgeMenu,
    category: '平均年齢'
  },
  annual_income: {
    key: 'annual_income',
    property: 'annual_income',
    initialValue: Set(),
    menu: averageAnnualIncomeMenu,
    category: '平均年収'
  }
};

/**
 * 資金調達フィルターの設定
 */
// menuからlabelMapを生成するヘルパー
const menuToLabelMap = (menu) => menu.reduce((acc, item) => ({ ...acc, [item.value]: item.name }), {});

// labelFormatter生成ヘルパー
const createFundraisingLabelFormatter = (prefix, menu) => {
  const labelMap = menuToLabelMap(menu);
  return (v) => `${prefix}: ${labelMap[v] || v}`;
};

export const FUNDRAISING_FILTER_CONFIG = {
  fundraising_days: {
    key: 'fundraising_days',
    property: 'fundraising_days',
    initialValue: '',
    menu: fundraisingDaysMenu,
    category: '資金調達（発表日）',
    type: 'select',
    sidebarLabel: '直近の調達',
    labelFormatter: createFundraisingLabelFormatter('資金調達', fundraisingDaysMenu)
  },
  fundraising_amount_range: {
    key: 'fundraising_amount_range',
    property: 'fundraising_amount_range',
    initialValue: Set(),
    menu: fundraisingAmountRangeMenu,
    category: '資金調達（金額）',
    type: 'set',
    sidebarLabel: '調達金額',
    labelFormatter: createFundraisingLabelFormatter('調達金額', fundraisingAmountRangeMenu)
  },
  fundraising_amount_type: {
    key: 'fundraising_amount_type',
    property: 'fundraising_amount_type',
    initialValue: Set(),
    menu: fundraisingAmountTypeMenu,
    category: '資金調達（金額タイプ）',
    type: 'set',
    sidebarLabel: '金額タイプ',
    tooltip: '今回の調達額か累計調達額かを絞り込みます',
    labelFormatter: createFundraisingLabelFormatter('金額タイプ', fundraisingAmountTypeMenu)
  },
  fundraising_round: {
    key: 'fundraising_round',
    property: 'fundraising_round',
    initialValue: Set(),
    menu: fundraisingRoundMenu,
    category: '資金調達（ラウンド）',
    type: 'set',
    sidebarLabel: 'ラウンド',
    labelFormatter: createFundraisingLabelFormatter('ラウンド', fundraisingRoundMenu)
  },
  fundraising_financing_type: {
    key: 'fundraising_financing_type',
    property: 'fundraising_financing_type',
    initialValue: Set(),
    menu: fundraisingFinancingTypeMenu,
    category: '資金調達（調達種別）',
    type: 'set',
    sidebarLabel: '調達手段',
    labelFormatter: createFundraisingLabelFormatter('調達手段', fundraisingFinancingTypeMenu)
  },
  fundraising_hiring_focus: {
    key: 'fundraising_hiring_focus',
    property: 'fundraising_hiring_focus',
    initialValue: false,
    category: '資金調達（採用注力）',
    type: 'boolean',
    sidebarLabel: '採用強化中の企業のみ',
    tooltip: '資金使途に採用が含まれる企業のみを表示します',
    labelFormatter: () => '採用強化中の企業のみ'
  },
  fundraising_investor_type: {
    key: 'fundraising_investor_type',
    property: 'fundraising_investor_type',
    initialValue: Set(),
    menu: fundraisingInvestorTypeMenu,
    category: '資金調達（投資家タイプ）',
    type: 'set',
    sidebarLabel: '投資家タイプ',
    labelFormatter: createFundraisingLabelFormatter('投資家', fundraisingInvestorTypeMenu)
  }
};



// WEBPACK FOOTER //
// ./src/constants/ExecutiveListSearchKeyConstants.js